<template>
  <div class="filter-wrapper">
    <label>{{ translation(filterName) }}</label>
    <v-autocomplete
      v-model="current"
      :items="list.data"
      :item-text="translatedName"
      item-value="value"
      :multiple="list.multiple"
      clearable
      :hide-details="true"
      :return-object = "list.returnObject"
      @change="setFilter">
      <template v-slot:prepend-item v-if="list.multiple && list.data && list.data.length">
        <v-list-tile ripple @click="toggleItem">
          <v-list-tile-action>
            <v-icon :color="current.length > 0 ? 'primary' : ''">
              {{ allIcon }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ translation('filters.select.select-all') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FilterSelect',
  props: {
    filterId: { type: String, required: true },
    filterKey: { type: String, required: true },
    filterName: { type: String, required: true }
  },
  computed: {
    ...mapGetters(['translation']),
    list () { return this.$store.getters.filterItemGen(this.filterId) },
    current: {
      set (val) { this.$store.commit('GEN_SET_SELECTED_FILTER_ITEM', { key: this.filterId, value: val }) }, // TODO handle val === 'undefined' for single item select on Clear
      get () { return this.$store.getters.selectedItemGen(this.filterId) }
    },
    selectedAll () { return this.current.length === this.list.data.length },
    selectedSome () { return this.current.length > 0 && !this.selectedAll },
    allIcon () {
      if (this.selectedAll) return 'check_box'
      if (this.selectedSome) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  methods: {
    toggleItem () {
      this.$nextTick(() => {
        this.selectedAll ? this.current = [] : this.current = this.list.data.map(item => item.value)
        this.setFilter()
      })
    },
    setFilter () {
      // emit event for fetching data
      this.$emit('update-filters')
    },
    translatedName (item) {
      return item.translatedName ? item.translatedName : item.name
    }
  }
}
</script>

<style lang="scss">
.filter-wrapper {
  text-align: left;
  label {
    font-weight: bold;
  }
  .v-text-field {
    padding-top: 0;
    .v-input__slot {
      padding: 0 5px;
      border: 1px solid rgba(5, 30, 72, .25) !important;
      border-radius: .2rem;
      &::before {
        border: none;
      }
    }
  }
}
</style>
